import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import sanitizeHtml from 'sanitize-html';
import Box from '@material-ui/core/Box';
import { useStyles } from './legalText.jss';

export default function LegalText() {
  const classes = useStyles();
  const initialData = useSelector((state) => state.carBooking.dictionaries);
  const [legalText, setLegalText] = useState('');
  const sanitizeLegalText = sanitizeHtml(legalText, {
    allowedAttributes: { a: ['href', 'target'] },
    allowedTags: ['a', 'br', 'p', 'strong']
  });

  useEffect(() => {
    if (!initialData) return;
    setLegalText(initialData?.legalText);
  }, [initialData]);

  return (
    <Box
      mb={7.5}
      mt={10}
      display="flex"
      mx="auto"
      px={2}
      maxWidth={1280}
      fontSize={14}
      className={classes.legalText}
    >
      <span dangerouslySetInnerHTML={{ __html: sanitizeLegalText }} />
    </Box>
  );
}
